import { useEffect, useState, useCallback } from 'react';

export const useGetCustomFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkFingerprint = useCallback((attempts) => {
    if (attempts <= 0) {
      setLoading(false);
      return undefined;
    }

    if (window.customFingerprint) {
      setFingerprint(window.customFingerprint);
      setLoading(false);
      return undefined;
    }
    const timeoutId = setTimeout(() => checkFingerprint(attempts - 1), 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      setLoading(false);
      return undefined;
    }

    const cleanup = checkFingerprint(5);

    return () => {
      if (cleanup && typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, [checkFingerprint]);

  return {
    fingerprint,
    loading,
  };
};
